var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJamPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8803 8.34867C11.9271 8.2752 11.9587 8.19309 11.9732 8.1072C11.9876 8.0213 11.9847 7.93338 11.9646 7.84864C11.9444 7.7639 11.9075 7.68406 11.8559 7.61387C11.8043 7.54368 11.7392 7.48455 11.6643 7.44L5.04966 3.41867C4.94211 3.35352 4.81874 3.31916 4.69299 3.31933C4.31966 3.31933 4.01766 3.61467 4.01766 3.97933V12.02C4.01766 12.1433 4.05299 12.264 4.11966 12.3687C4.31699 12.678 4.73299 12.7727 5.04966 12.58L11.6643 8.55933C11.7517 8.506 11.8263 8.43333 11.881 8.348L11.8803 8.34867ZM12.3777 9.68L5.76366 13.7007C4.81366 14.2787 3.56366 13.994 2.97299 13.0667C2.77268 12.7544 2.66645 12.391 2.66699 12.02V3.98C2.66699 2.886 3.57366 2 4.69366 2C5.07166 2 5.44233 2.10333 5.76366 2.29867L12.3777 6.32C13.3277 6.89733 13.619 8.11733 13.0277 9.04533C12.8637 9.30267 12.641 9.52 12.3777 9.68Z",
    fill: "#232627",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJamPlay);
export default __webpack_public_path__ + "static/media/jam_play.45b12463ca171527c0b138e66b550f5f.svg";
export { ForwardRef as ReactComponent };